import React, {Component} from 'react';
import {Row, Col, Card, CardBody, Button} from "reactstrap";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";
import {
  getDealroomProjects,
  getDealroomFinStr,
  projectErrorsObjSet,
  setDealRoomFinSchemaErrorsObjectsCreating,
  getDealroomProjectsScenarios,
  getScenarioProjects,
  getDealroomFinStrScenarios,
  getScenarioFinStrs,
  setFinStrErrorsNull,
  editDealroom
} from "../../../store/actions";
import DealroomProjects from "./DealroomProjects";
import Modal from './ScenarioCreateModal';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import DealroomScenarioProjects from "./DealroomScenarioProjects";
import DealroomFinStructures from "./DealroomFinStructures";

class DealroomView extends Component {
  state = {
    choosenProjects: [],
    onFinStrcheckbox: -1,
    modalToggle: false,
    activeProjectTab: -1,
    activeFinStrTab: -1,
    modalType: '',
  };

  componentDidMount() {
    this.getData();
  }

  getData = () => {
    const {
      getDealroomProjects, getDealroomFinStrScenarios,
      getDealroomFinStr, match, projectErrorsObjSet, setFinStrErrorsNull,
      setDealRoomFinSchemaErrorsObjectsCreating, getDealroomProjectsScenarios
    } = this.props;

    getDealroomProjects(match.params.id).then((res) => {
      projectErrorsObjSet(res.payload.length);
    });
    getDealroomProjectsScenarios(match.params.id);
    setFinStrErrorsNull();
    getDealroomFinStr(match.params.id).then((res) => {
      setDealRoomFinSchemaErrorsObjectsCreating(res.payload.length);
    });
    getDealroomFinStrScenarios(match.params.id);
  };

  componentDidUpdate(prevProps) {
    const {match} = this.props;
    if (match.params.id !== prevProps.match.params.id) {
      this.getData();
    }
  }

  addScenario = (modalType) => {
    const {editPanding} = this.props;
    const {choosenProjects, onFinStrcheckbox} = this.state;

    if (!editPanding) {
      if (modalType === 'project') {
        if (choosenProjects.length > 0) {
          this.toggle(modalType);
        } else {
          NotificationManager.warning('Choose Project', "There are not choosen projects ", 5000);
        }
      } else {
        if (onFinStrcheckbox !== -1) {
          this.toggle(modalType);
        } else {
          NotificationManager.warning('Choose Financical Structure', "There isn't choosen financical structure ", 5000);
        }
      }
    } else {
      NotificationManager.warning('Save all changes', "Can't Create Scenario ", 5000);
    }
  };

  toggle = (modalType) => {
    const {modalToggle} = this.state;

    this.setState({modalToggle: !modalToggle, modalType})
  };

  onProjectChoose = (index, IsProjectCheckboxChecked) => {
    let {choosenProjects} = this.state;

    if (IsProjectCheckboxChecked) {
      choosenProjects.push(index);
    } else {
      choosenProjects = choosenProjects.filter((pr) => {
        return pr !== index && pr
      })
    }

    this.setState({choosenProjects});
  };

  removeChoosenProjects = (key, val) => {
    this.setState({[key]: val})
  };

  onFinStrChoose = (IsFinStrCheckboxChecked, index) => {
    let {onFinStrcheckbox} = this.state;

    if (IsFinStrCheckboxChecked) {
      onFinStrcheckbox = index;
    } else {
      onFinStrcheckbox = -1;
    }
    this.setState({onFinStrcheckbox});
  };

  editDealroom = () => {
    const {dealroomProjects, dealroomFinStr, editDealroom, match, location, history} = this.props;
    const result = {name: location.state.name};

    result.projects = dealroomProjects.map((project) => project.user_project);
    result.financial_structures = dealroomFinStr.map((finStr) => finStr.user_financial_structure);
    editDealroom(result, match.params.id)
      .then((res) => {
        NotificationManager.success('Dealroom successfuly edited', "", 5000);
        history.push({
          pathname: "/dealroom-view/" + res.payload.data.dealroom,
          state: {name: location.state.name}
        });
      })
  };

  changeTab = (i, key) => {
    this.setState({[key]: i});
  };

  render() {
    const {
      dealroomProjects, dealroomFinStr,
      match, location, scenarioFinStrShow, getScenarioFinStrs, setDealRoomFinSchemaErrorsObjectsCreating,
      scenarioProjectsShow, dealroomProjectsScenarios, getScenarioProjects, dealroomFinStrScenarios
    } = this.props;
    const {onFinStrcheckbox, choosenProjects, modalToggle, modalType, activeProjectTab, activeFinStrTab} = this.state;
    console.log(dealroomFinStrScenarios);
    return !location.state ? <Redirect to={'/dealroom'}/> : (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardBody>
                <h1>Dealroom {location.state.name}</h1>
                <div>
                  <ul className="nav nav-tabs mt-5 mb-5 deal-room">
                    <li className="nav-item">
                      <a className={"nav-link " + (activeProjectTab === -1 ?
                        "active" : '')}>
                                   <span onClick={() => {
                                     this.props.getDealroomProjects(match.params.id).then((res) => {
                                       this.props.projectErrorsObjSet(res.payload.length);
                                     });
                                     this.changeTab(-1, 'activeProjectTab');
                                   }
                                   }>Base case</span>
                      </a>
                    </li>

                    {dealroomProjectsScenarios && dealroomProjectsScenarios.map((scenario, i) => {
                      return <li className="nav-item"><a className={"nav-link " + (activeProjectTab === i ?
                        "active" : '')} key={scenario.id}
                                                         onClick={() => {
                                                           getScenarioProjects(scenario.id).then((res) => {
                                                             this.props.projectErrorsObjSet(res.payload.user_projects.length);
                                                           });
                                                           this.changeTab(i, 'activeProjectTab');
                                                         }}>{scenario.name}</a></li>;
                    })}
                    <li className="nav-item">
                      {!scenarioProjectsShow &&
                      <span className="btn btn-link btn-plus" onClick={() => this.addScenario('project')}>+</span>}
                    </li>
                  </ul>
                </div>
                {dealroomProjects &&
                (!scenarioProjectsShow ?
                    <DealroomProjects projects={dealroomProjects}
                                      onProjectChoose={this.onProjectChoose}
                                      removeChoosenProjects={this.removeChoosenProjects}
                                      choosenProjects={choosenProjects}
                    />
                    : <DealroomScenarioProjects projects={dealroomProjects}
                                                dealroomId={match.params.id}
                                                NotificationManager={NotificationManager}
                                                changeTab={this.changeTab}
                                                dealroomProjectsScenariosLength={dealroomProjectsScenarios.length}
                                                removeChoosenProjects={this.removeChoosenProjects}/>
                )}
                <hr/>
                <div style={{marginBottom: '20px'}}>
                  <div>
                    <ul className="nav nav-tabs mt-5 mb-5 deal-room">
                      <li className="nav-item">
                        <a className={"nav-link " + (activeFinStrTab === -1 ?
                          "active" : '')}>
                      <span onClick={() => this.props.getDealroomFinStr(match.params.id).then((res) => {
                        this.props.setDealRoomFinSchemaErrorsObjectsCreating(res.payload.length);
                        this.changeTab(-1, 'activeFinStrTab')
                      })}>Base case</span>
                        </a>
                      </li>

                      {dealroomFinStrScenarios && dealroomFinStrScenarios.map((scenario, i) => {
                        return <li className="nav-item">
                          <a className={"nav-link " + (activeFinStrTab === i ?
                            "active" : '')} key={scenario.id}
                             onClick={() => {
                               getScenarioFinStrs(scenario.id);
                               setDealRoomFinSchemaErrorsObjectsCreating(1)
                               this.changeTab(i, 'activeFinStrTab')

                             }
                             }>{scenario.name}</a>
                        </li>;
                      })}

                      <li className="nav-item">
                        {!scenarioFinStrShow &&
                        <button className="btn btn-link btn-plus" onClick={() => this.addScenario('finStr')}>+</button>}
                      </li>
                    </ul>
                  </div>
                  <DealroomFinStructures onFinStrChoose={this.onFinStrChoose}
                                         onFinStrcheckbox={onFinStrcheckbox}
                                         dealroomId={match.params.id}
                                         NotificationManager={NotificationManager}
                                         removeChoosenProjects={this.removeChoosenProjects}
                                         changeTab={this.changeTab}
                                         dealroomFinStrScenariosLength={dealroomFinStrScenarios ? dealroomFinStrScenarios.length: 0}
                                         dealroomFinStr={dealroomFinStr}
                  />
                </div>
                {!scenarioProjectsShow && !scenarioFinStrShow &&
                <Button color="primary" style={{float: 'right'}} onClick={this.editDealroom}>SAVE</Button>}

                <NotificationContainer/>

              </CardBody>
            </Card>
          </Col>
        </Row>
        <
          Modal
          isOpen={modalToggle}
          toggle={this.toggle}
          modalType={modalType}
          choosenProjects={choosenProjects}
          onFinStrcheckbox={onFinStrcheckbox}
        />
      </div>
    )
      ;
  }
}

const mapStateToProps = state => {
  return {
    dealroomFinStr: state.dealroom.dealroomFinStr,
    dealroomProjects: state.dealroom.dealroomProjects,
    editPanding: state.dealroom.editPanding,
    scenarioProjectsShow: state.dealroom.scenarioProjectsShow,
    scenarioFinStrShow: state.dealroom.scenarioFinStrShow,
    newProjectScenarioCreating: state.dealroom.newProjectScenarioCreating,
    dealroomProjectsScenarios: state.dealroom.dealroomProjectsScenarios,
    dealroomFinStrScenarios: state.dealroom.dealroomFinStrScenarios,
  }
};

export default connect(mapStateToProps, {
  getDealroomProjects,
  projectErrorsObjSet,
  getDealroomProjectsScenarios,
  getScenarioProjects,
  getDealroomFinStrScenarios,
  getScenarioFinStrs,
  setFinStrErrorsNull,
  editDealroom,
  getDealroomFinStr,
  setDealRoomFinSchemaErrorsObjectsCreating
})(DealroomView);



// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/DealroomView.js